import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { AddCommissionsComponent } from 'src/app/Comission/add-commissions/add-commissions.component';
import { ALERT_TYPE } from 'src/app/constants';
import { UploadImageComponent } from 'src/app/Images/upload-image/upload-image.component';
import { LoanRequestMessageComponent } from 'src/app/MessageClipboard/loan-request-message/loan-request-message.component';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';
import { Contact } from 'src/model/contact.model';
import { Customer } from 'src/model/customer.model';
import { EPF } from 'src/model/epf.model';
import { Loan } from 'src/model/loan.model';
import { LoanRequest } from 'src/model/loanRequest.model';
import { Profile } from 'src/model/profile.model';
import { CompanyService } from 'src/services/company.service';
import { ProfileService } from 'src/services/profile.service';
import { AddContactComponent } from '../add-contact/add-contact.component';

@Component({
    selector: 'app-add-loan',
    templateUrl: './add-loan.component.html',
    styleUrls: ['./add-loan.component.scss'],
    providers: [DatePipe],
    standalone: false
})

export class AddLoanComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);
  private _formBuilder = inject(UntypedFormBuilder);
  private cdr = inject(ChangeDetectorRef);
  private datepipe = inject(DatePipe);
  private profileService = inject(ProfileService);
  private companyService = inject(CompanyService);

  loggedInUser: string;
  loggedInRole: number;
  loggedInCompanyName: string;
  loggedInCompanyId: number;

  companyAccountList: Account[] = [];
  selectedAccountId: number;

  withAnotherLoan = false;
  @Input() oboCompanyId: number;
  @Input() selectedCustomer: Customer;
  @Input() selectedProfile: Profile;
  @Input() epfDetails: EPF;
  @Input() isLead = false;
  @Input() isEPFExtra = false;
  @Input() previousEPFLoans: Loan[] = [];
  @Input() needRestrictedRequest: boolean;
  @Input() allowEPF: boolean;

  @Input() isOverlap = false;
  @Input() batchDate: Date;

  @Input() isManualKeyIn = false;

  @Output() passEntry = new EventEmitter<any>();

  loanList: Loan[] = [];

  nextTaskDate: Date;
  error = false;

  disabledSubmit = false;

  hasApplicationForm: boolean;

  nonExistedNecessaryFileTypeList: string[] = [];

  hasEPFStatement: boolean;
  hasCustomerAcknowledgement: boolean;
  hasEPFProof: boolean;
  isEPF = false;
  payWithSimpan = false;

  ratio = 0;

  //test
  loanFormGroup: UntypedFormGroup;
  contactFormGroup: UntypedFormGroup;
  isOptional = false;
  contactList: Contact[] = [];
  request: LoanRequest;
  restrictedReqeustRemark: string;

  @Input() isManualElevate = false;
  elevateError = "";
  elevateLoanError = "";
  elevateSuggestedSettlement = "";

  requestRemark = "";

  ngOnInit(): void {
    this.loggedInCompanyName = sessionStorage.getItem('companyName');
    this.loggedInCompanyId = Number(sessionStorage.getItem('companyId'));
    this.loggedInUser = sessionStorage.getItem('username');
    this.loggedInRole = Number(sessionStorage.getItem('roleId'));

    if (this.sharedService.isOperatingUser()) {
      this.bindFormGroupInfo();
    }

    //if requireConsentForm property is not found in session storage, get this info
    const requireConsentForm = sessionStorage.getItem("requireConsentForm")
    if (requireConsentForm == undefined)
      this.getCompanyInfo(this.loggedInCompanyId);

    // this.getApplicationFormExistence(this.loggedInCompanyId);

    // this.getAllLoanSchemes();
    this.getAllAccountsOfCompany(this.loggedInCompanyId);

    // this.nextTaskDate = this.calculateNextTaskDate();
    this.calculateNextTaskDate();

    if (this.selectedProfile.Reserve > 0 && this.isOverlap == false)
      this.openPayBySimpanConfirmation();
  }

  bindFormGroupInfo() {
    this.loanFormGroup = this._formBuilder.group({
      loanList: [this.loanList]
    });

    this.contactFormGroup = this._formBuilder.group({
      contactList: [this.contactList]
    });
  }

  openUploadEPFStatementModal() {
    const modalRef = this.sharedService.openModal(UploadImageComponent);

    modalRef.componentInstance.selectedCustomerId = this.selectedCustomer.ID;
    modalRef.componentInstance.supportingDocType = this.enums.EPF_STATEMENT;
    //get added loan
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      if (entry != undefined)
        this.hasEPFStatement = true;
    });

    modalRef.result.then(() => {
      //detect changes
      this.cdr.detectChanges();
    })
  }

  openUploadCustomerAcknowledgementModal() {
    const modalRef = this.sharedService.openModal(UploadImageComponent);

    modalRef.componentInstance.selectedCustomerId = this.selectedCustomer.ID;
    modalRef.componentInstance.supportingDocType = this.enums.ACKNOWLEDGEMENT;
    //get added loan
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      if (entry != undefined)
        this.hasCustomerAcknowledgement = true;
    });

    modalRef.result.then(() => {
      //detect changes
      this.cdr.detectChanges();
    })
  }

  openUploadEPFProofModal() {
    const modalRef = this.sharedService.openModal(UploadImageComponent);

    modalRef.componentInstance.selectedCustomerId = this.selectedCustomer.ID;
    modalRef.componentInstance.supportingDocType = this.enums.EPF_PROOF;
    //get added loan
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      if (entry != undefined)
        this.hasEPFProof = true;
    });

    modalRef.result.then(() => {
      //detect changes
      this.cdr.detectChanges();
    })
  }

  openPayBySimpanConfirmation() {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "This customer has RM " + this.selectedProfile.Reserve + " SIMPAN. You want to PAY BY SIMPAN?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.payWithSimpan = true;
    });
  }

  countSelectedGaurantor() {
    let count = 0;
    if (this.contactList.length == 0)
      return 0;
    else {
      for (let i = 0; i < this.contactList.length; i++) {
        if (this.contactList[i].IsSelected == true)
          count++;
      }

      return count;
    }
  }

  addContact() {
    const modalRef = this.sharedService.openModal(AddContactComponent);
    modalRef.componentInstance.viewCustomerId = this.selectedCustomer.ID;

    //get added loan
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      const contact = entry;

      //append added loan to loan list
      this.contactList.push(contact);
    });

    modalRef.result.then(() => {
      //detect changes
      this.cdr.detectChanges();
    })
  }

  deleteContact(i: number) {
    this.contactList.splice(i, 1);
  }

  loadEPFInfos() {
    if (this.isEPF == true)
      this.getContactInfo();
  }

  calculateNextTaskDate() {
    //get next month's date
    let taskDateStr = new Date(new Date().getFullYear(), new Date().getMonth() + 1, this.selectedProfile.SalaryDay);

    try {
      var taskDate = taskDateStr;
    }
    catch {
      // if date string not valid, set last day of the month
      taskDateStr = new Date(new Date().getFullYear(), new Date().getMonth() + 2, 0);
    }
    this.nextTaskDate = taskDate;
  }

  getLoan1Data(loan: Loan) {
    this.loanList[0] = loan;
    this.selectedAccountId = undefined;
  }

  getLoan2Data(loan: Loan) {
    this.loanList[1] = loan;
    this.selectedAccountId = undefined;
  }

  calculateTotalOnHand() {
    let total = 0;
    for (let i = 0; i < this.loanList.length; i++) {
      if (this.loanList[i] != undefined) {
        let duitLebihTotal = 0;
        if (this.loanList[i].Extras.length > 0) {
          for (let j = 0; j < this.loanList[i].Extras.length; j++)
            duitLebihTotal += this.loanList[i].Extras[j].Amount;
        }

        total += this.loanList[i].Principal + this.loanList[i].Reserve - duitLebihTotal - this.loanList[i].InterestCharge - this.loanList[i].StampAmount -
          this.loanList[i].ServiceCharge
      }
    }

    return total;
  }

  calculateTotalProcessing() {
    let total = 0;
    for (let i = 0; i < this.loanList.length; i++) {
      if (this.loanList[i] != undefined)
        total += this.loanList[i].InterestCharge;
    }

    return total;
  }

  calculateTotalStampAndSC() {
    let total = 0;
    for (let i = 0; i < this.loanList.length; i++) {
      if (this.loanList[i] != undefined)
        total += this.loanList[i].StampAmount + this.loanList[i].ServiceCharge;
    }

    return total;
  }

  calculateTotalDuitLebih() {
    let total = 0;
    for (let i = 0; i < this.loanList.length; i++) {
      if (this.loanList[i] != undefined) {
        if (this.loanList[i].Extras.length > 0) {
          for (let j = 0; j < this.loanList[i].Extras.length; j++) {
            total += this.loanList[i].Extras[j].Amount;
          }
        }
      }
    }
    return total;
  }

  openUploadApplicationFormModal() {
    const modalRef = this.sharedService.openModal(UploadImageComponent);

    modalRef.componentInstance.selectedCustomerId = this.selectedCustomer.ID;
    modalRef.componentInstance.isApplicationForm = true;
    modalRef.componentInstance.isSingleType = false

    modalRef.componentInstance.passEntry.subscribe((entry) => {
      this.getAllFileExitence();
    });

    // this.hasApplicationForm = true;
  }

  openUploadSupportingDocModal() {
    const modalRef = this.sharedService.openModal(UploadImageComponent);

    modalRef.componentInstance.selectedCustomerId = this.selectedCustomer.ID;
    modalRef.componentInstance.isSingleType = false;
    //get added loan
    // modalRef.componentInstance.passEntry.subscribe((entry) => {
    //   if (entry != undefined)

    // });

    modalRef.result.then(() => {
      //detect changes
      this.cdr.detectChanges();
    })
  }

  reset() {
    this.activeModal.close();
  }

  dismissModal() {
    this.activeModal.dismiss();
  }

  constructReqeust() {
    const guarantorList: Contact[] = [];
    for (let i = 0; i < this.contactList.length; i++) {
      if (this.contactList[i].IsSelected == true) {
        guarantorList.push(this.contactList[i]);
      }
    }

    // When constructing request, need to make reserve amount into negative

    this.loanList[0].Reserve = (this.loanList[0].Reserve != undefined) ? - this.loanList[0].Reserve : 0;

    //check if there is any on behalf of company id, if exist, then use that company id, else use logged in company id
    const companyId = (this.oboCompanyId == undefined) ? this.selectedCustomer.CompanyId : this.oboCompanyId;

    this.request = new LoanRequest(this.selectedCustomer.ID, this.epfDetails.Amount, this.epfDetails.Date, guarantorList, this.epfDetails.HasIAccount, undefined, this.loanList[0], undefined, this.selectedProfile.ID,
      this.requestRemark, undefined, undefined, undefined, undefined
      , undefined, this.selectedCustomer.CompanyCode, this.selectedCustomer.ICNumber, this.selectedCustomer.Name, companyId)

    //emit this request back to parent component
    this.passEntry.emit(this.request);
    this.activeModal.close();
  }

  checkEPFLoanBeforeSubmitting() {
    const errorStr = this.validateEPFLoan();
    if (errorStr == '') {
      // var epfDate = this.getFormValue("epfDate");
      // var epfAmount = this.getFormValue("epfAmount");
      // var epfCategory = this.sharedService.checkEPFLimitCategory(epfDate, epfAmount);
      // var currentLoanSettlement = this.sharedService.calculateEPFSettlementAmountWithCharges(this.loanList[0]);

      // // EPF set Limit
      // if (this.isEPF == true && this.enums.epfLimitList[epfCategory].ElevatedSettlementRate != undefined &&
      //   this.sharedService.calculatePreviousEPFLoanSettlement(this.previousEPFLoans) + currentLoanSettlement > this.sharedService.getEPFElevateSettlement(epfDate, epfAmount)) {
      //   this.elevateSuggestedSettlement += "\n\n- The loan requested has the settlement ratio more than " + this.enums.epfLimitList[epfCategory].ElevatedSettlementRate * 100 + "%. This case will be sent to BOSS FOR APPROVAL"
      //   this.confirmBeforeElevatingCase();
      // }
      // else if (this.isManualElevate == true)
      //   this.confirmBeforeElevatingCase();
      // else
      //   this.submitEPFLoanRequest(false)
      this.constructReqeust();
    }
    else
      this.sharedService.openAlert("Please fill in all the necessary fields CORRECTLY" + errorStr, ALERT_TYPE.DANGER);
  }

  //add: add in restriction for senior within certain age must send loan request other than EPF scheme
  addRestrictedLoanRequest() {
    const string = this.checkNull();
    if (string != "") {
      this.sharedService.openAlert(string, ALERT_TYPE.DANGER);
    } else {
      const loanInfoData = {
        "principal": this.loanList[0].Principal,
        "scheme": this.loanList[0].Scheme,
        "term": this.loanList[0].Term,
        "interestRate": this.sharedService.roundToDec(this.loanList[0].InterestRate, 11),
        "stamp": this.loanList[0].StampAmount,
        "serviceCharge": this.loanList[0].ServiceCharge,
        "extras": this.loanList[0].Extras,
        "processingRate": this.loanList[0].ProcessingRate,
        "reserve": -this.loanList[0].Reserve,
      }
      const data = {
        "profileId": this.selectedProfile.ID,
        "loanInfo": loanInfoData,
        "requestOn": new Date().toISOString(),
        "remark": this.restrictedReqeustRemark
      }

      const loanInfo = new Loan(undefined, this.selectedProfile.ID, this.loanList[0].Principal, this.loanList[0].StampAmount, undefined, undefined, new Date(), this.selectedCustomer.CompanyId, undefined, this.loanList[0].Scheme, this.loanList[0].InterestRate, this.loanList[0].Term, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined,
        undefined, undefined, undefined, this.loanList[0].ServiceCharge, this.loanList[0].Extras, undefined, undefined, undefined, this.loanList[0].ProcessingRate);
      this.request = new LoanRequest(this.selectedCustomer.ID, undefined, undefined, undefined, undefined, undefined, loanInfo, undefined, this.selectedProfile.ID, this.restrictedReqeustRemark, undefined, new Date(), undefined, undefined, undefined, this.selectedCustomer.CompanyCode, this.selectedCustomer.ICNumber, this.selectedCustomer.Name, this.selectedCustomer.CompanyId);

      const xhr = this.restApi.postRequest(this.constructApi.getAddLoanRequest(), data)
      xhr.onreadystatechange = () => {
        if (xhr.readyState == 4) {
          this.disabledSubmit = false;
          //if success , then proceed
          if (xhr.status == 200) {
            var json = JSON.parse(xhr.responseText);
            this.request.ID = Number(json.id);

            if (this.sharedService.isBranchAccountHandler()) {
              const modalRef = this.sharedService.openModal(LoanRequestMessageComponent);

              modalRef.componentInstance.requestList = [this.request];
              modalRef.componentInstance.isDirty = true;
              modalRef.componentInstance.isEPFRequest = false;
              this.reset();
            }
            else {
              window.location.reload();
            }
          }
          else {
            this.disabledSubmit = false;
            //show error message
            this.sharedService.openAlert(json.error, ALERT_TYPE.DANGER)
          }
        }
      }
    }
  }

  getFileExistence(type: string, index: number) {
    const xhttp = this.restApi.getRequest(this.constructApi.getCustomerTypedFileExistence(this.selectedCustomer.ID, type))
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const result = JSON.parse(xhttp.responseText);

        if (Boolean(result) == false)
          this.nonExistedNecessaryFileTypeList.push(this.enums.customerNecessaryDocsString[index]);
      }
    };
  }

  async getCompanyInfo(companyId: number) {
    const comp = await this.companyService.getCompanyDetails(companyId);
    sessionStorage.setItem( "requireConsentForm", comp.RequireConsentForm.toString());
        this.getAllFileExitence();
  }

  getAllFileExitence() {
    this.nonExistedNecessaryFileTypeList = [];
    let fileList;
    //for this case, CONSENT FORM is not necessary, leave for server to check
    const requireConsentForm = sessionStorage.getItem("requireConsentForm")
    if (requireConsentForm == "true")
      fileList = this.enums.customerNecessaryDocs;
    else
      fileList = this.enums.customerNecessaryDocs.slice(0, 4);

    for (let i = 0; i < fileList.length; i++) {
      this.getFileExistence(fileList[i], i);
    }
  }

  private getAllAccountsOfCompany(companyId: number) {
    const xhttp = this.restApi.getRequest(this.constructApi.getAccountsOfCompany(companyId))
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const account = new Account(json.id, json.number, json.name, json.holderName, json.balance, json.companyId, json.username);

          this.companyAccountList.push(account);
        }
        );
      }
    };
  }

  setSelectedAccount(accountId: number) {
    if (accountId === this.selectedAccountId)
      return true
    else
      return false;
  }

  async updateProfile() {
    this.selectedProfile = await this.profileService.updateProfile(this.selectedProfile);
    this.sharedService.openAlert("Successfully updated customer profile salary details", ALERT_TYPE.SUCCESS);
  }

  addNewLoanObj() {
    if (this.withAnotherLoan == true)
      this.loanList[1] = undefined;
    else
      this.loanList.splice(1, 1);
  }

  async updateSalaryDetailsAndTaskDate() {
    if (this.isEPF == true && this.epfDetails.Date == undefined)
      this.sharedService.openAlert("Please enter a valid EPF SETTLEMENT DATE!", ALERT_TYPE.DANGER);
    else {
      if (this.selectedProfile.SalaryDay <= 31 && this.selectedProfile.SalaryDay >= 1) {
        await this.updateProfile();
        this.calculateNextTaskDate();
      }
      else {
        this.sharedService.openAlert("Please enter a valid day of month! (1-31)", ALERT_TYPE.DANGER);
      }
    }
  }

  confirmBeforeAddLoan() {
    let errorMessage = "";

    for (let i = 0; i < this.loanList.length; i++) {
      var stampNull;
      var scNull;
      var extraNull;
      if (this.loanList[i].Scheme != 'HUTANG') {
        stampNull = this.loanList[i].StampAmount == 0;
        scNull = this.loanList[i].ServiceCharge == 0
        extraNull = this.loanList[i].Extras.length == 0;

        if (stampNull == true || scNull == true || extraNull == true) {
          errorMessage += "Your Loan " + Number(i + 1) + "'s STAMP / SERVICE CHARGE / DUIT LEBIH=0\n";
        }
      }
    }
    if (errorMessage != "") {
      errorMessage += "\n Are you sure?"
      const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
      modalRef.componentInstance.message = errorMessage;

      modalRef.result.then((confirm) => {
        if (confirm)
          this.sendOrAddLoan();
      });
    }
    else
      this.sendOrAddLoan();
  }

  isBalanceInsufficient(balance: number) {
    if (this.calculateTotalOnHand() > balance) {
      return true;
    }
    else
      return false;
  }

  checkLoanNull() {
    for (let i = 0; i < this.loanList.length; i++) {
      if (this.loanList[i] == undefined)
        return true;
    }
    return false;
  }

  roundTo2Dec(num: number) {
    return Math.round(num * 100) / 100
  }

  checkNull() {
    let string = "";
    this.elevateLoanError = "";
    for (let i = 0; i < this.loanList.length; i++) {
      const interestRateNull = (this.loanList[i].Scheme == "HUTANG") ?
        this.loanList[i].InterestRate == undefined : this.loanList[i].InterestRate == undefined || this.loanList[i].InterestRate <= 0;
      if (this.loanList[i].Principal == undefined || this.loanList[i].Principal === 0)
        string += "\n- Principal";
      else if (this.loanList[i].Scheme == undefined)
        string += "\n- Skim";
      else if (this.loanList[i].Term == undefined || this.loanList[i].Term === 0 || this.loanList[i].Term > 48)
        string += "\n- Term";
      else if (interestRateNull)
        string += "\n- Interest Rate";
      else if (this.loanList[i].Scheme == 'EPF' && this.isEPFExtra == false) {
        if (this.loanList[i].Term <= 3) {
          if (this.roundTo2Dec(this.loanList[i].InterestRate) < (this.enums.MINIMUM_EXTRA_EPF_RATE * 100)) {
            if (this.isManualElevate == true)
              this.elevateLoanError += "\n- Interest Rate less than" + (this.enums.MINIMUM_EXTRA_EPF_RATE * 100) + "% for loan less than 3 months";
            else
              string += "\n- Interest Rate less than " + (this.enums.MINIMUM_EXTRA_EPF_RATE * 100) + "% for loan less than 3 months";
          }
        }
        else {
          if (this.roundTo2Dec(this.loanList[i].InterestRate) < (this.enums.MINIMUM_NEW_EPF_RATE * 100))
            string += "\n- Interest Rate less than" + (this.enums.MINIMUM_NEW_EPF_RATE * 100) + "%";
        }
      }
      else if (this.loanList[i].Scheme == 'EPF' && this.isEPFExtra == true && this.roundTo2Dec(this.loanList[i].InterestRate) < (this.enums.MINIMUM_EXTRA_EPF_RATE * 100))
        string += "\n- EPF EXTRA - Interest Rate less than " + (this.enums.MINIMUM_EXTRA_EPF_RATE * 100) + "%";

      else if (this.loanList[i].Scheme != "HUTANG" && (this.loanList[i].InterestCharge == undefined || this.loanList[i].InterestCharge === 0))
        string += "\n- Interest Charge";
      else if (this.selectedAccountId == undefined && this.loanList[i].Scheme != 'EPF' && this.isOverlap == false && this.needRestrictedRequest == false)
        string += "\n- Issue Account";
      else if (this.selectedProfile.Salary == undefined || this.selectedProfile.Salary == 0)
        string += "\n- Salary"
      else if (this.selectedProfile.SalaryDay == undefined || this.selectedProfile.SalaryDay == 0)
        string += "\n- Salary Day"

      if (this.isEPF == true && this.loanList[i].Extras.length == 0 || (this.isEPF == true && this.calculateAdsDuitLebihTotal() < this.loanList[i].Principal * this.enums.MINIMUM_ADS_RATE))
        string += "\n- Please at least key in 2% in duit lebih for ADS"

      if (this.isEPF == true) {
        //settlement charges empty check
        if (this.loanList[i].SettlementCharges == undefined) {
          string += "\n - Settlement Charges cannnot leave empty!"
        }
        else {
          if (this.sharedService.checkIsWholeNumber(this.loanList[i].SettlementCharges.Stamp) == false)
            string += "\n - Settlement Stamp cannot have cents!";
          if (this.sharedService.checkIsWholeNumber(this.loanList[i].SettlementCharges.ServiceCharge) == false)
            string += "\n - Settlement SC cannot have cents!";
          if (this.sharedService.checkIsWholeNumber(this.loanList[i].SettlementCharges.Extras) == false)
            string += "\n - Settlement DL cannot have cents!";
          if (this.loanList[i].SettlementCharges.HandlingCharge != undefined && this.sharedService.checkIsWholeNumber(this.loanList[i].SettlementCharges.HandlingCharge) == false)
            string += "\n - Handling Charge cannot have cents!";
        }
      }

      //STAMP LIMIT
      //IF not EPF SCHEME, make sure STAMP is <= than MAXIMUM STAMP LIMIT
      if (this.loanList[i].StampAmount == undefined) {
        string += "\n- STAMP cannnot leave empty!";
      }
      else {
        if (this.isEPF == false && this.loanList[i].StampAmount > this.enums.MAXIMUM_STAMP_NORMAL_SCHEME)
          string += "\n- Please make sure your STAMP not more than RM " + this.enums.MAXIMUM_STAMP_NORMAL_SCHEME;
      }

      //SC LIMIT
      //IF not EPF SCHEME, make sure SC is <= than MAXIMUM SC LIMIT
      if (this.loanList[i].ServiceCharge == undefined) {
        string += "\n- SC cannnot leave empty!";
      }
      else {
        if (this.isEPF == false && this.loanList[i].ServiceCharge > this.enums.MAXIMUM_SC_NORMAL_SCHEME)
          string += "\n- Please make sure your SC not more than RM " + this.enums.MAXIMUM_SC_NORMAL_SCHEME;
      }

      if (string != "")
        return string;
      else
        continue;
    }
    return string;
  }

  calculateAdsDuitLebihTotal() {
    let total = 0;
    for (let i = 0; i < this.loanList.length; i++) {
      if (this.loanList[i] != undefined) {
        if (this.loanList[i].Extras.length > 0) {
          for (let j = 0; j < this.loanList[i].Extras.length; j++) {
            if (this.loanList[i].Extras[j].Subtype == this.enums.ADS_SUBTYPE_ID)
              total += this.loanList[i].Extras[j].Amount;
          }
        }
      }
    }
    return total;
  }

  getContactInfo() {
    let index = 0;
    const xhttp = this.restApi.getRequest(this.constructApi.getCustomerContact(this.selectedCustomer.ID));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));
        // console.log(jsonArray);

        jsonArray.forEach(json => {
          const contact = new Contact(json.id, json.name, json.icNumber, json.number, json.address, json.customerId, json.relation, json.remark, false);
          //add customer instance into customer list
          this.contactList.push(contact);
          this.getCustomerContactPhotoExisted(contact, index)
          index++;
        }
        );
      }
    };
  }

  getCustomerContactPhotoExisted(contact: Contact, index: number) {
    const xhttp = this.restApi.getRequest(this.constructApi.getCustomerContactPhotoExistence(this.selectedCustomer.ID, contact.ID));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const result = Boolean(JSON.parse((xhttp.responseText)));
        this.contactList[index].PhotoExisted = result
      }
    };
  }

  checkGuarantorValidity() {
    let string = "";
    if (this.contactList.length == 0 || this.contactList == undefined)
      string += "Please at least add a guarantor!";
    else {
      const selectedContact = this.contactList.filter((contact: Contact) => (contact.IsSelected == true));
      if (selectedContact.length == 0 || selectedContact == undefined) {
        string += "Please at least add a guarantor!";
      }

      else {
        const selectedContactWithoutPicture = selectedContact.filter((contact: Contact) => (contact.PhotoExisted == false || contact.PhotoExisted == undefined));
        if (selectedContactWithoutPicture.length > 0)
          string += "Please make sure all your guarantors contains picture!";
      }
    }

    return string
  }

  validateCheckGurantorValidity() {
    const string = this.checkGuarantorValidity();
    if (string == "")
      this.constructReqeust();
    else {
      this.sharedService.openAlert(string, ALERT_TYPE.DANGER);
    }
  }

  isEPFGurantorStepCompleted() {
    if (this.checkGuarantorValidity() != "")
      return false;
    else return true;
  }

  isEPFLoanStepCompleted() {
    if (this.loanList.length > 0) {
      // if the loan is filled in with details
      //check again if the epf amount is a valid amount
      //if yes then only continue to check loan's limit to make sure can find the correct loan limit category
      if (this.checkNull() != undefined && this.checkNull() == '')
        return true;
      else
        return false;
    }

    //if there's no loan details, return false= not completed
    else
      return false;
  }

  validateEPFLoan() {
    const string = this.checkNull()

    if (string != '')
      return string;
    else return '';
    // this.sharedService.openAlert("Please fill in all the necessary fields CORRECTLY" + string, ALERT_TYPE.DANGER);
  }

  checkIfManualEPFDateIsValid() {
    if (this.epfDetails.Date != undefined && this.selectedCustomer.DOB != undefined) {
      const calculatedEPFDate = this.sharedService.calculateEPFDate(new Date(this.selectedCustomer.DOB));
      const formattedEPFDate = this.datepipe.transform(new Date(this.epfDetails.Date), "yyyy-MM-dd");
      const formattedCalculateEPFDate = this.datepipe.transform(new Date(calculatedEPFDate), "yyyy-MM-dd");
      if (formattedEPFDate == formattedCalculateEPFDate)
        return true;
      else
        return false;
    }
  }

  sendOrAddLoan() {
    if (this.isOverlap == true) {
      this.passEntry.emit(this.loanList);
      this.reset();
    }
    else
      this.addLoan();
  }

  addLoan() {
    this.disabledSubmit = true;
    const dataArr = [];

    for (let i = 0; i < this.loanList.length; i++) {
      const data = {
        "loanCode": this.loanList[i].LoanCode,
        "principal": this.loanList[i].Principal,
        "profileID": this.selectedProfile.ID,
        "dateCreated": this.loanList[i].DateCreated.toISOString(),
        "scheme": this.loanList[i].Scheme,
        "term": this.loanList[i].Term,
        "interestRate": this.sharedService.roundToDec(this.loanList[i].InterestRate, 11),
        "stamp": this.loanList[i].StampAmount,
        "serviceCharge": this.loanList[i].ServiceCharge,
        "extras": this.loanList[i].Extras,
        "processingRate": this.loanList[i].ProcessingRate,
        "accountId": Number(this.selectedAccountId),
        "reserve": -this.loanList[i].Reserve
      }
      dataArr.push(data)
    }

    const xhr = this.restApi.postRequest(this.constructApi.getAddLoans(), dataArr)
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        //if success , then proceed
        if (xhr.status == 200) {
          const jsonArray = JSON.parse(xhr.responseText);

          jsonArray.forEach(json => {
            const loan = new Loan(json.id, json.profileId, json.principal, json.stampAmount, json.receiptNumber,
              json.status, json.dateted, json.companyId, json.companyName,
              json.scheme, json.interestRate, json.term, json.customerId, json.customerName,
              json.icNumber, json.interestCharge, json.issuer, json.loanCode, json.arrear, json.principalPaid,
              json.repayment, json.reserve)

            //if successfully added loan, need to assign commission
            if (this.loggedInRole == this.enums.BRANCH_MANAGER)
              this.openAssignCommissionModal(loan);

            this.passEntry.emit(loan);
          }
          );
          this.reset();
        }
        else {
          //show error message
          this.sharedService.openAlert(JSON.parse(xhr.responseText).error, ALERT_TYPE.DANGER)
        }
      }
    }
  }

  submit() {
    let usedReserve = 0;
    for (let i = 0; i < this.loanList.length; i++) {
      usedReserve += this.loanList[i].Reserve;
    }

    if (this.checkLoanNull()) {
      this.sharedService.openAlert("WARNING! You left a loan empty", ALERT_TYPE.DANGER);
    }
    else if (usedReserve > this.selectedProfile.Reserve) {
      this.sharedService.openAlert("WARNING! You used more than your available simpan", ALERT_TYPE.DANGER);
    }
    else if (this.nonExistedNecessaryFileTypeList.length > 0) {
      let message = "";
      for (let i = 0; i < this.nonExistedNecessaryFileTypeList.length; i++) {
        message += "- " + this.nonExistedNecessaryFileTypeList[i] + "\n";
      }
      this.sharedService.openAlert("WARNING! Please add: \n" + message, ALERT_TYPE.DANGER);
    }
    else {
      const string = this.checkNull()
      if (string == "") {
        this.confirmBeforeAddLoan();
      }
      else
        this.sharedService.openAlert("Please fill in all the necessary fields CORRECTLY" + string, ALERT_TYPE.DANGER);
    }
  }

  openAssignCommissionModal(loan: Loan) {
    const modalRef = this.sharedService.openModal(AddCommissionsComponent);
    modalRef.componentInstance.selectedLoan = loan;
  }
}
